import BaseApi from "./baseApi";
import type { IdLike } from "../types";

class ServiceApi extends BaseApi {
  async addService(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
      {
        url: "/service/addservice",
        data: data,
        method: "post"
      }
    )
  }

  async getAllServiceList(data: Record<string, unknown> | object): Promise<any> {
    return await this.API(
        {
            url:"/service/getallservicelist",
            method: "get"
        }
    )
}

async getAllServiceSearch(data: Record<string, unknown> | object): Promise<any> {
  return await this.API(
      {
          url:"/service/getAllServiceSearch",
          method: "get"
      }
  )
}

async deleteService(data: Record<string, unknown> | object, service_id: IdLike): Promise<any> {
  return await this.API({
    url: `/service/deleteservice/${service_id}`,
    data: data,
    method: 'delete'
  })
}
async searchKey (data: Record<string, unknown> | object, key: string): Promise<any> {
  return await this.API(
      {
          url:`/service/search/${key}`,
          method: "get"
      }
  )
}
async updateService(data: Record<string, unknown> | object, service_id: IdLike): Promise<any> {
  return await this.API({
    url: `/service/updateservice/${service_id}`,
    data: data,
    method: 'put'
  })
}

}

export default ServiceApi;
